module.exports = __webpack_public_path__ + "img/dp-dy-sy8.0.7dbc5689.png";